var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoGeojson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "4.11458in",
    height: "4.51667in",
    viewBox: "0 0 814 893",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#332C2B",
    d: "M265 198c5,0 10,-2 14,-5 4,-3 6,-7 7,-12 2,-5 2,-14 2,-27 0,-13 1,-21 1,-25 1,-6 2,-11 4,-15 2,-4 4,-7 7,-10 2,-2 6,-4 10,-5 3,-1 8,-1 14,-1l6 0 0 18 -3 0c-8,0 -13,1 -16,4 -2,3 -3,9 -3,19 0,20 -1,33 -2,38 -1,8 -3,14 -7,19 -3,4 -8,8 -15,11 8,4 14,9 18,16 4,8 6,19 6,36 0,14 0,23 0,26 0,5 2,9 4,11 3,2 8,3 15,3l3 0 0 18 -6 0c-7,0 -13,-1 -16,-2 -5,-2 -9,-4 -12,-8 -3,-4 -5,-9 -6,-15 -1,-6 -2,-16 -2,-30 0,-13 -1,-23 -2,-28 -1,-5 -3,-9 -7,-12 -4,-4 -9,-5 -14,-5l0 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#332C2B",
    d: "M549 198c-6,0 -10,-2 -14,-5 -4,-3 -6,-7 -8,-12 -1,-5 -1,-14 -1,-27 -1,-13 -1,-21 -1,-25 -1,-6 -2,-11 -4,-15 -2,-4 -4,-7 -7,-10 -2,-2 -6,-4 -10,-5 -3,-1 -8,-1 -14,-1l-7 0 0 18 4 0c8,0 13,1 15,4 3,3 4,9 4,19 0,20 1,33 2,38 1,8 3,14 7,19 3,4 8,8 15,11 -8,4 -14,9 -18,16 -4,8 -6,19 -6,36 0,14 0,23 0,26 -1,5 -2,9 -5,11 -2,2 -7,3 -14,3l-4 0 0 18 7 0c7,0 13,-1 16,-2 5,-2 9,-4 12,-8 3,-4 5,-9 6,-15 1,-6 2,-16 2,-30 0,-13 0,-23 2,-28 1,-5 3,-9 7,-12 4,-4 8,-5 14,-5l0 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#332C2B",
    d: "M406 126c20,0 37,17 37,37 0,1 0,1 0,1 0,1 0,1 0,1l0 0c-1,24 -23,48 -37,57 -15,-9 -36,-33 -37,-57l0 0c0,0 -1,0 -1,-1 0,0 0,0 0,-1 0,-20 17,-37 38,-37zm0 18c10,0 19,9 19,19 0,11 -9,20 -19,20 -11,0 -20,-9 -20,-20 0,-10 9,-19 20,-19z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#332C2B",
    stroke: "#332C2B",
    strokeWidth: 1.37363,
    cx: 406,
    cy: 240,
    r: 7
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#332C2B",
    strokeWidth: 5.49372,
    points: "406,240 366,257 443,274"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#332C2B",
    stroke: "#332C2B",
    strokeWidth: 1.37363,
    cx: 366,
    cy: 257,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#332C2B",
    stroke: "#332C2B",
    strokeWidth: 1.37363,
    cx: 443,
    cy: 274,
    r: 15
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#332C2B",
    strokeWidth: 32.9647,
    strokeLinejoin: "round",
    points: "100,16 576,16 713,154 713,877 100,877"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#332C2B",
    stroke: "#332C2B",
    strokeWidth: 27.4702,
    strokeLinejoin: "round",
    d: "M576 16l137 138 -68 0c-38,0 -69,-31 -69,-69l0 -69z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#EF8359",
    y: 370,
    width: 814,
    height: 387,
    rx: 28,
    ry: 28
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    d: "M125 577l0 -16 43 0 0 39c-4,4 -10,7 -18,10 -8,4 -16,5 -24,5 -10,0 -19,-2 -27,-6 -8,-5 -13,-11 -17,-19 -4,-8 -6,-17 -6,-26 0,-10 2,-20 6,-28 5,-8 11,-14 19,-18 7,-3 14,-5 24,-5 12,0 22,3 28,8 7,5 12,12 14,21l-20 4c-1,-5 -4,-9 -8,-12 -4,-2 -8,-4 -14,-4 -9,0 -16,3 -21,8 -5,6 -7,14 -7,25 0,12 2,20 7,26 5,6 12,9 21,9 4,0 8,-1 12,-2 4,-2 8,-4 11,-6l0 -13 -23 0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    points: "186,613 186,515 259,515 259,532 206,532 206,553 255,553 255,570 206,570 206,597 261,597 261,613"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    d: "M274 565c0,-10 1,-19 4,-26 3,-5 6,-9 9,-13 4,-4 9,-7 13,-9 6,-3 13,-4 21,-4 15,0 27,5 35,14 9,9 13,21 13,37 0,16 -4,29 -13,38 -8,9 -20,13 -34,13 -15,0 -27,-4 -35,-13 -9,-9 -13,-22 -13,-37zm20 -1c0,11 3,20 8,25 5,6 12,9 20,9 8,0 14,-3 19,-9 5,-5 8,-14 8,-25 0,-11 -3,-20 -8,-25 -5,-6 -11,-9 -19,-9 -9,0 -15,3 -20,9 -5,5 -8,14 -8,25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    d: "M420 515l20 0 0 62c0,8 -1,15 -2,19 -2,6 -6,10 -11,14 -5,3 -11,5 -20,5 -9,0 -17,-3 -22,-8 -5,-5 -8,-13 -8,-24l19 -2c0,5 1,9 2,12 2,3 6,5 10,5 4,0 8,-1 9,-4 2,-2 3,-8 3,-15l0 -64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    d: "M456 581l19 -1c1,6 4,11 7,14 4,3 9,4 15,4 6,0 11,-1 14,-4 3,-2 5,-6 5,-9 0,-3 -1,-5 -2,-6 -1,-2 -4,-3 -7,-4 -2,-1 -8,-3 -16,-5 -11,-2 -18,-6 -22,-9 -6,-6 -9,-13 -9,-20 0,-5 1,-10 4,-14 3,-5 7,-8 12,-10 5,-3 12,-4 19,-4 13,0 22,3 28,8 6,6 10,13 10,22l-20 1c-1,-5 -3,-9 -5,-11 -3,-2 -7,-3 -13,-3 -6,0 -10,1 -13,3 -2,2 -3,4 -3,6 0,3 1,5 3,6 2,2 8,5 18,7 9,2 17,5 21,7 5,2 8,6 11,10 3,4 4,9 4,16 0,5 -2,11 -5,16 -3,4 -7,8 -13,10 -6,3 -13,4 -21,4 -13,0 -22,-3 -29,-9 -7,-5 -11,-14 -12,-25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    d: "M549 565c0,-10 1,-19 4,-26 2,-5 5,-9 9,-13 4,-4 8,-7 13,-9 6,-3 13,-4 21,-4 15,0 26,5 35,14 9,9 13,21 13,37 0,16 -4,29 -13,38 -8,9 -20,13 -34,13 -15,0 -27,-4 -35,-13 -9,-9 -13,-22 -13,-37zm20 -1c0,11 3,20 8,25 5,6 12,9 19,9 8,0 15,-3 20,-9 5,-5 8,-14 8,-25 0,-11 -3,-20 -8,-25 -5,-6 -11,-9 -20,-9 -8,0 -14,3 -19,9 -5,5 -8,14 -8,25z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    points: "660,613 660,515 679,515 719,581 719,515 738,515 738,613 718,613 678,549 678,613"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGeojson);
export default __webpack_public_path__ + "static/media/logo_geojson.0715b344297aa3d7ec04e19d442bc527.svg";
export { ForwardRef as ReactComponent };